export default {
  path: 'manage-employees',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage Employees',
      component: () => import('@/views/menus/employee/ManageEmployees'),
      meta: {
        permission: true
      }
    }
  ]
}
